import { createSelector } from 'reselect';
import { getCurrentState } from 'src/modules/routing/selectors/getCurrentState';

export const getCurrentLocation = createSelector([
  getCurrentState,
], (state) => state?.location ?? null);
